import { ActiveToolsMenuCard } from '../LeftPane/ActiveToolsMenuCard';
import { useAvailableTools } from '../../hooks';
import type { MCPServer } from '../../types';

interface ExpertToolsButtonProps {
  className?: string;
  mcpServers: MCPServer[];
}

export const ExpertToolsButton = ({
  className,
  mcpServers,
}: ExpertToolsButtonProps) => {
  const { availableTools, isLoading } = useAvailableTools(mcpServers);

  return (
    <ActiveToolsMenuCard
      availableTools={availableTools}
      toolsLoading={isLoading}
      triggerClassName={className}
      align="right"
    />
  );
};
